import { CfetBaseComponent, CfetService, CfetRegExContant } from './../../cfet-core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-password-validation-tooltip',
    templateUrl: './password-validation-tooltip.component.html',
    styleUrls: ['./password-validation-tooltip.component.scss'],
    standalone: false
})
export class PasswordValidationTooltipComponent extends CfetBaseComponent implements OnInit {

  @Input() index: any;
  @Input() consecutiveFlagFlow: boolean;
  @Output() emitedPassword = new EventEmitter<any>();
  @Output() isFocusOn = new EventEmitter<any>();

  errorFlag = false;
  errorFlagArray = [];
  aplhaUCPatternFlag = false;
  aplhaLCPatternFlag = false;
  numPatternFlag = false;
  specialCharsPatternFlag = false;
  pwdLengthFlag = false;
  pasteMouseClick = false;
  showPwd = [];
  hasSequenceCharsFlag = [];
  ruleHeaders = ['lengthRule', 'capitalLetterRule', 'smallLetterRule', 'numRule', 'specialCharsRule'];
  unRuleHeaders = ['length24', 'repeating3', 'sequence3'];
  isFocus = false;
  isSonim = /SONIM-XP5800|SONIM-XP3800/i.test(navigator.userAgent);

  constructor(public cfetService: CfetService) { super(); }

  ngOnInit() {
    if (!this.index) {
      this.index = 0;
    }
    this.cfetService.pwdObj.currentPassword[this.index] = '';
    if (!this.consecutiveFlagFlow) {
      this.consecutiveFlagFlow = false;
    }
    this.errorFlagArray[this.index] = false;
    this.hasSequenceCharsFlag[this.index] = false;
    this.ruleOperator(false, this.index);
    this.showPwd[this.index] = false;
    this.isFocusOn.emit(false);
  }

  pwdKeyup(event, index) {
    this.cfetService.pwdObj.isErrorCodeArray[index] = '';
    this.cfetService.pwdObj.currentPassword[index] = (event && event.target && event.target.value) ? event.target.value : '';
    this.ruleOperator(!!this.cfetService.pwdObj.currentPassword[index], this.index);
    this.emitedPassword.emit({
      ...{ pwd: this.cfetService.pwdObj.currentPassword[index], index },
      ...this.cfetService.pwdObj.pdRules[this.index]
    });
    this.isFocus = true;
    this.isFocusOn.emit(true);
  }

  setEmptyCurrentPassword(index) {
    if (this.cfetService.pwdObj.isErrorCodeArray[index]) {
      this.cfetService.pwdObj.currentPassword[index] = '';
    }
  }

  setEmptyPdRules(index) {
    if (!this.cfetService.pwdObj.pdRules[index]) {
      this.cfetService.pwdObj.pdRules[index] = {};
    }
  }

  ruleOperator(initial, index) {
    this.setEmptyCurrentPassword(index);
    this.setEmptyPdRules(index);
    if (this.cfetService.pwdObj.currentPassword && this.cfetService.pwdObj.currentPassword[index]) {
      this.hasSequenceCharsFlag[index] = this.hasSequenceChars(this.cfetService.pwdObj.currentPassword[index]);
    }
    for (const val of this.ruleHeaders) {
      const regexval =  CfetRegExContant[val] ? !!this.cfetService.pwdObj.currentPassword[index].match(CfetRegExContant[val]) :
        this.cfetService.pwdObj.currentPassword[index].length >= 8;
      this.cfetService.pwdObj.pdRules[index][val] = initial ? regexval : false;
    }
    for (const value of this.unRuleHeaders) {
      const rg = CfetRegExContant[value] ?
        !this.cfetService.pwdObj.currentPassword[index].match(CfetRegExContant[value]) :
        (this.cfetService.pwdObj.currentPassword[index].length <= 24);
      let val = (value === 'sequence3') ? !this.hasSequenceCharsFlag[index] : rg;
      this.cfetService.pwdObj.pdRules[index][value] = initial ? val : true;
    }
  }

  hasSequenceChars(str) {
    for (let i = 0; i < str.length; i++) {
      if (((String.fromCharCode(str[i].toLowerCase().charCodeAt(0) + 1) === (str[i + 1] && str[i + 1].toLowerCase())) &&
        (String.fromCharCode(str[i + 1].toLowerCase().charCodeAt(0) + 1) === (str[i + 2] && str[i + 2].toLowerCase()))) ||
        ((String.fromCharCode(str[i].toLowerCase().charCodeAt(0) - 1) === (str[i + 1] && str[i + 1].toLowerCase())) &&
          (String.fromCharCode(str[i + 1].toLowerCase().charCodeAt(0) - 1) === (str[i + 2] && str[i + 2].toLowerCase())))) {
        return true;
      }
    }
    return false;
  }

  checkForSpecialChars(event) {
    if (event.key === ' ') {
      if (event.keyCode) {
        event.preventDefault();
      } else {
        event.key = '';
      }
    }
    return event.key;
  }

  checkForSpecialCharsPaste(event, index) {
    const str = event.clipboardData.getData('text');
    event.target.value = str.replace(' ', '');
    if (!this.pasteMouseClick) {
      this.pwdKeyup(event, index);
    }
    this.pasteMouseClick = false;
    event.preventDefault();
  }

  resetField(event, index) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.cfetService.pwdObj.currentPassword[index] = '';
      this.ruleOperator(false, this.index);
      this.emitedPassword.emit({ pwd: '', index });
    }
  }

  showHidePassword(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showPwd[this.index] = !this.showPwd[this.index];
    }
  }

  pwdBlur(index) {
    this.errorFlagArray[index] = this.cfetService.pwdObj.currentPassword[index] ?
      Object.values(this.cfetService.pwdObj.pdRules[this.index]).includes(false) : false;
    this.emitedPassword.emit({
      ...{ pwd: this.cfetService.pwdObj.currentPassword[index], index: index, eFlag: this.errorFlagArray },
      ...this.cfetService.pwdObj.pdRules[this.index]
    });
    this.isFocus = false;
    this.isFocusOn.emit(false);
  }

}